import { SearchX } from 'lucide-react'
import { Link } from 'react-router'
import { Button, EmptyState } from '@/components/ui'
import { useDocumentTitle } from '@/lib/hooks'
import { t } from '@/lib/i18n'

/** In page "not found" panel for unknown communities, posts and courses (UI.md section 7). */
export function NotFoundState({ title, description }: { title?: string; description?: string }) {
  useDocumentTitle([t('Page not found')])
  return (
    <EmptyState
      icon={SearchX}
      title={title ?? t('We could not find that page')}
      description={description ?? t('The link may be broken, or the page may have moved.')}
      action={
        <Button asChild variant="primary">
          <Link to="/">{t('Go home')}</Link>
        </Button>
      }
    />
  )
}
